import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface CreateBackupDestinationContext {
  hid: string;
}

export interface CreateBackupDestinationService {
  open(context: CreateBackupDestinationContext): Observable<boolean>;
  // Templates have no computer to take a company from, so the destination goes to every company the admin can see;
  // emits the created storage account id — the created destination is looked up by it in the reloaded list
  openForAllCompanies(): Observable<string | null>;
}

export const CREATE_BACKUP_DESTINATION = new InjectionToken<CreateBackupDestinationService>('CREATE_BACKUP_DESTINATION');
